import { AxiosError } from 'axios';

export const getErrorCodeOrResponse = (error: AxiosError<{ code: string }>) =>
  error.response?.data.code || String(error);
